import React from 'react';
import { observer } from 'mobx-react';

const PackageOverviewRightMenu = observer(() => {
  return <></>;
});

export default PackageOverviewRightMenu;
